import { useAppSelector } from "../../../store/hooks";
import style from "./productSlide.module.css";
import ProductSingle from "../single/ProductSingle";
import { SwiperSlide, Swiper } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Placeholder from "../../placeHolder/PlaceHolder";
import { placeHolder } from "../../../types/common";
import { useRef } from "react";
const ProductSlide = () => {
  const { data, loading } = useAppSelector((state) => state.products.products);
  const swiperRef = useRef<any>(null);
  const scoreLink = useAppSelector(
    (state) => state.game.sendScore.data?.data.coupon.link
  );
  return (
    <div className={style.product}>
      <div className={style["product-inner"]}>
        {!loading ? (
          <>
            <Swiper
              ref={swiperRef}
              modules={[Navigation, Pagination]}
              breakpoints={{
                320: {
                  slidesPerView: 2.2,
                  spaceBetween: 8,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 8,
                },
              }}
              className={style["product-slide"]}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
            >
              {data?.data.data.slice(0, 30).map((item, index) => (
                <SwiperSlide
                  key={index}
                  className={style["product-slide-item"]}
                >
                  <ProductSingle product={item} width="100%" />
                </SwiperSlide>
              ))}
              <SwiperSlide className={style["product-slide-item"]}>
                <a
                  href={scoreLink}
                  rel="noopener noreferrer"
                  className={`wrapper-end ${style.more}`}
                  target="_blank"
                >
                  <span>مشاهده همه</span>
                </a>
              </SwiperSlide>
            </Swiper>
            <button
              className={`swiper-button-prev desktop ${style.prev}`}
            ></button>
            <button
              className={`swiper-button-next desktop ${style.next}`}
            ></button>
          </>
        ) : (
          <div className={style["placeholder-slide_container"]}>
            <Placeholder
              type={placeHolder.CARD}
              number={4}
              className={style["placeholder-slide"]}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductSlide;
